import { render, staticRenderFns } from "./PersonalContacts.vue?vue&type=template&id=4e867bac&"
import script from "./PersonalContacts.vue?vue&type=script&lang=js&"
export * from "./PersonalContacts.vue?vue&type=script&lang=js&"
import style0 from "./PersonalContacts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports